import React from 'react';
import { appName, phone, phoneDisplay } from '../../config/config';
import { NavLink } from 'react-router-dom';

const AboutSection = () => {
    return ( <>
        <div className="container-fluid wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5">
            <div className="row g-5">
                <div className="col-lg-7">
                    <div className="section-title section-title-plane position-relative pb-3 mb-5">
                        <h5 className="fw-bold text-primary text-uppercase">About Us</h5>
                        <h1 className="mb-0">Opening Doors to a World of Possibilities</h1>
                    </div>
                    <p className="mb-4 text-justify"><b>{appName}</b> is a trusted name in global immigration and visa consulting, providing expert guidance and end-to-end solutions for individuals aspiring to settle, study, or travel abroad. With a strong presence across Punjab and Haryana, we have built our reputation on integrity, transparency, and results-driven service.</p>
                    <p className='mb-4 text-justify'>We specialize in Permanent Residency (PR) applications, Student Visas, Visitor Visas, and a range of immigration services designed to make international relocation smooth and stress-free. Our experienced team stays updated with the latest immigration policies and procedures to ensure every client receives accurate advice and personalized support at every stage of their journey.</p>
                    <p className='mb-4 text-justify'>At {appName}, we believe that “everyone is an immigrant at some point.” Guided by this philosophy, our mission is to empower dreams, connect borders, and create opportunities for a better future. We strive to simplify complex visa processes and help individuals and families achieve their global aspirations with confidence and peace of mind.</p>
                    <div className="row g-0 mb-3 d-none">
                        <div className="col-sm-6 wow zoomIn" data-wow-delay="0.2s">
                            <h5 className="mb-3"><i className="fa fa-check text-primary me-3"></i>Quality Services</h5>
                            <h5 className="mb-3"><i className="fa fa-check text-primary me-3"></i>Expert Team</h5>
                        </div>
                        <div className="col-sm-6 wow zoomIn" data-wow-delay="0.4s">
                            <h5 className="mb-3"><i className="fa fa-check text-primary me-3"></i>Tailored Solutions</h5>
                            <h5 className="mb-3"><i className="fa fa-check text-primary me-3"></i>Transparent Process</h5>
                        </div>
                    </div>
                    <div className="d-flex align-items-center mb-4 wow fadeIn" data-wow-delay="0.6s">
                        <div className="bg-primary d-flex align-items-center justify-content-center rounded" style={{width: 60, height: 60}}>
                            <i className="fa fa-phone-alt text-white"></i>
                        </div>
                        <div className="ps-4">
                            <h5 className="mb-2">Call to ask any question</h5>
                            <a href={'tel:'+phone}><h4 className="text-primary mb-0">{phoneDisplay}</h4></a>
                        </div>
                    </div>
                    <NavLink to="/contact" className="btn btn-primary py-3 px-5 mt-3 wow zoomIn" data-wow-delay="0.9s">Submit a Query</NavLink>
                </div>
                <div className="col-lg-5" style={{minHeight: 500}}>
                    <div className="position-relative h-100">
                        <img className="position-absolute w-100 h-100 rounded wow zoomIn" data-wow-delay="0.9s" src="/assets/img/about.jpg" style={{objectFit: 'cover'}}/>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </> );
}
 
export default AboutSection;